import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`🚀 TASK: Check the Status of the Training`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Check your Training Cards. All should be green and say `}<inlineCode parentName="p">{`Deployed`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/46_training.png",
          "alt": "image"
        }}></img>
      </li>
    </ol>
    <InlineNotification kind="success" mdxType="InlineNotification">
      <p><strong parentName="p">{`You have successfully finished this Chapter`}</strong></p>
      <p>{`You are now done with the chapter on Training the models.`}</p>
      <p>{`Please continue to the next chapter to learn how to Test and Demo the installation.`}</p>
    </InlineNotification>
    <InlineNotification kind="error" mdxType="InlineNotification"> 
      <p>{`You have successfully completed installing and configuring CP4AIOPS.`}</p>
      <p>{`→ Please continue to the next chapter to learn how to test your installation .`}</p>
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      